export const auditLogEvent = {
  // The same reconciliation can have different frozen values in different events.
  AuditLogReconciliationSnapshot: {
    keyFields: false as const,
  },
  // The list query caps an event's references at five and the panel query pages up to 250. One
  // normalized AuditLogEvent per id would let either read overwrite the other's references, so
  // each query keeps its own copy of the event and the two query policies own the paging.
  AuditLogEvent: {
    keyFields: false as const,
  },
}
